import ApplyRounding from './ApplyRounding';

const MAX_DISPLAYABLE_PRICE = 1_000_000_000;

export function isDisplayablePrice(value) {
  const numericValue = Number(value);
  return (
    Number.isFinite(numericValue) &&
    numericValue > 0 &&
    Math.abs(numericValue) < MAX_DISPLAYABLE_PRICE
  );
}

export function formatDisplayPrice(value, fallback = 'unknown') {
  if (!isDisplayablePrice(value)) return fallback;
  return `$${ApplyRounding(Number(value), 2)}`;
}
